// Fonction modifiée pour créer un en-tête d'année
export function createYearHeader(year) {
  const header = document.createElement('div');
  header.className = 'year-header';

  const h2 = document.createElement('h2');
  h2.textContent = year;

  header.appendChild(h2);
  return header;
}